var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPasswordError = function SvgPasswordError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0F23",
    fillRule: "evenodd",
    d: "M.72.22a.75.75 0 0 0 0 1.061L4.437 5 .719 8.719A.75.75 0 0 0 1.781 9.78L5.5 6.062l3.718 3.719a.75.75 0 0 0 1.063-1.062L6.562 5l3.719-3.718A.75.75 0 0 0 9.218.219L5.5 3.938 1.781.219A.75.75 0 0 0 .721.22",
    clipRule: "evenodd"
  })));
};
export default SvgPasswordError;